import { useContext, useEffect, useState } from 'react';
import { displayMoneyFormat } from '../../util/util';
import { TenantContext } from '../../context/tenant-context';
import { DatePicker } from '../../components/date-picker/date-picker';
import { DateTime } from 'luxon';

export const CashPaymentInput = ({
  balanceDue,
  setAmount,
  setPaymentDate,
}: {
  balanceDue: number;
  setAmount: (a: number) => void;
  setPaymentDate?: (a: DateTime | undefined) => void;
}) => {
  const { configuration } = useContext(TenantContext);
  const [amountTendered, setAmountTendered] = useState<number>(0);
  const [selectedPaymentDate, setSelectedPaymentDate] = useState<DateTime | undefined>(DateTime.now());

  useEffect(() => {
    setAmount(Math.min(amountTendered, balanceDue));
  }, [amountTendered]);

  return (
    <div className="flex flex-column gap-2">
      {setPaymentDate && (
        <div className="flex justify-between items-center">
          <span>Payment Date</span>
          <span>
            <DatePicker
              value={selectedPaymentDate}
              onChange={(d) => {
                setSelectedPaymentDate(d);
                setPaymentDate(d);
              }}
              placeholder="Date From"
              alignDropdownRight
              clearable
            />
          </span>
        </div>
      )}
      <div className="flex justify-between items-center">
        <span>Balance</span>
        <span>{displayMoneyFormat(balanceDue, configuration?.currency)}</span>
      </div>
      <div className="flex justify-between  items-center">
        <span>Amount Tendered</span>
        <input
          type="number"
          step="0.01"
          className="text-right [appearance:textfield] w-[10rem]"
          value={amountTendered}
          onChange={(e) => setAmountTendered(+e.target.value)}
        />
      </div>
      <div className="flex justify-between items-center">
        <span>Change</span>
        <span>
          {displayMoneyFormat(amountTendered > balanceDue ? amountTendered - balanceDue : 0, configuration?.currency)}
        </span>
      </div>
    </div>
  );
};
